import * as yup from "yup";

import { UserSummary } from "@/model/User/UserSummary";

export const EditTrainingCourseValidation = (trainerOptions: UserSummary[]) => {
	const trainerIds = trainerOptions.map((x) => x.Id);

	return yup.object().shape({
		CourseManagerId: yup
			.number()
			.test("valid-trainer", "Select a trainer", (value) =>
				trainerIds.includes(value),
			),
		Name: yup.string().required("Name is required"),
	});
};
